import { IconButton, Skeleton, Snack, Snackbar, StatusIconProtoProps, Table, TableCell, TableHeading } from "@nike/eds";
import { FC, useState } from "react";
import { useI18nContext } from "../../../context/language/use-i18n-context";
import {ts} from './i18n';
import { QrModal } from "../../visitor-pass/qr-modal/qr-modal";
import './my-pass.css';
import { useSponsorContext } from "../../../context/Sponsor";

export const MyPass: FC = () => {
    const { i18nString } = useI18nContext();
    const [isModelOpen, setModalOpen ] = useState(false); 
    const {sponsor}= useSponsorContext();
    const [snackBar, setSnackbar] = useState({ showSnack: false,message: '', snackStatus: "success" as StatusIconProtoProps["status"] });
    return (
        <>
            <section className="eds-spacing--p-48">
                <header className='eds-type--display-5 eds-spacing--mb-16'>
                    <h2 data-testid='my-pass-header' className='h2_font eds-flex eds-flex--justify-content-center'>{i18nString(ts.EMPLOYEE_MY_PASS)}</h2>
                </header>
                {sponsor? (
                <div className='eds-flex eds-flex--justify-content-center eds-elevation-shadow-3'>
                    <Table width='100%'>
                        <thead>
                            <tr>
                                <TableHeading className='eds-type-title-3'> Name</TableHeading>
                                <TableHeading className='eds-flex eds-flex--justify-content-flex-end eds-type-title-3'> Actions</TableHeading>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <TableCell className="font">{sponsor?.displayName}</TableCell>
                                <TableCell  className='eds-flex eds-flex--justify-content-flex-end'>
                                    <IconButton
                                        label='send-email'
                                        aria-label="send email"
                                        size="small"
                                        onClick={()=>{setModalOpen(true)}}
                                        icon={'InboxFilled'}
                                        variant="ghost"   
                                        data-testid="send-email"                                     
                                    >
                                    </IconButton>
                                </TableCell>
                            </tr>
                        </tbody>
                    </Table>
                </div>) 
                :(<>
                    {Array.from({ length: 2 }).map((_, index) => (
                        <Skeleton
                            key={index}
                            height={50}
                            width={`${100}%`}
                            style={{ margin: 'var(--eds-space-16)' }}
                        />
                    ))}
                    </>)}
                <QrModal onDismiss={() => setModalOpen(false)} isVisible={isModelOpen} setSnackbar={setSnackbar}/>
                <Snackbar>
                {snackBar.showSnack && (
                    <Snack id="snack-bar"
                        autoDismissDuration={5000}
                        status={snackBar.snackStatus}
                        onDismiss={() => setSnackbar(prevState => ({ ...prevState, showSnack: false }))}
                        data-testid="snack-bar"
                    >
                        {snackBar.message}
                    </Snack>
                )}
            </Snackbar>
            </section>
        </>
    )

}